import React, { useContext } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { Account } from "../account/account";
import { Home } from "../components/home/home";
import Configuration from "../configurationMenu";
import { useHasPermission } from "../context/userContext";
import { RouterContext } from "../globalContext";
import TrendingsV2Index from "../pages/trendings-v2";

const MESFMainRouter = () => {
	const CustomRoutes: any = useContext(RouterContext);
	const hasPermissionTo = useHasPermission();
	const canShowSettings = hasPermissionTo("ui.navbar.settings");

	return (
		<>
			<Routes>
				<Route path="/" element={<Navigate replace to="/home" />} />

				{canShowSettings && (
					<Route path="/configuration/*" element={<Configuration />} />
				)}
				<Route path="/account" element={<Account />} />
				<Route path="/trendings-v2" element={<TrendingsV2Index />} />

				<Route path="/home" element={<Home />} />
			</Routes>
			<CustomRoutes />
		</>
	);
};
export default MESFMainRouter;
